<template>
  <div>
    <md-card id="siview-config" align="Left" style="margin-top: 4rem;min-height: 4rem">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">history</i>
        </div>
        <h4 class="title">SiView Config</h4>
      </md-card-header>
      <md-card-area v-if="organizations && !isLoading">
        <div id="org_shop_relation_card" class="d-flex flex-column">
          <div class="item d-flex flex-row justify-content-between org-item" style="padding: 12px 24px; gap: 12px;" 
              v-for="(org, index) in organizations">
            <div class="d-flex flex-column">
              <p class="d-flex">Organization: <strong>&nbsp;{{ org.organizationName }}</strong></p>
            
              <div class="d-flex flex-row align-items-center" style="gap: 8px" v-if="org.shopIds && org.shopIds.length > 0">
                <p>Siview ShopIds: </p>
                <div v-for="(shopId) in org.shopIds">
                  <div class="d-flex cheap">
                    <p> {{ shopId }} - {{ shopNamesObject[shopId] }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="d-flex">
                <p class="warning-color">No ShopId related to this organization</p>
              </div>

              <div class="d-flex flex-row align-items-center" style="gap: 8px" v-if="cylinderOptionsObject[org.organizationId]">
                <p>Default Cylinder option: </p>
                <div class="d-flex">
                  <p> {{ formatCylinder(cylinderOptionsObject[org.organizationId]) }}</p>
                </div>
              </div>
              <div v-else class="d-flex">
                <p class="warning-color">No Default Cylinder option related to this organization</p>
              </div>
            </div>
            <div class="icon-btn pointer" style="width: 52px;height:52px;display:flex" @click.stop="editOrgRelation(org)">
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="bottom">Edit</md-tooltip>
            </div>
          </div>
        </div>



        <md-dialog id="#siview_shopId_relation_modal" :md-active.sync="showEditModal"
                   v-if="showEditModal && orgToEdit">
          <md-dialog-title>Organization: {{ orgToEdit.organizationName }} </md-dialog-title>
          <md-dialog-content>
            <md-field>
              <label for="specialization">Related SiView ShopId</label>
              <md-select v-model="shopIdControl" name="shopId" multiple>
                <md-option v-for="(item) in shopIds" :key="item.id" :value="item.id">
                  {{ item.id }} - {{ item.name }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <label for="specialization">Default Cylinder Option</label>
              <md-select v-model="cylinderOptionControl" name="shopId">
                <md-option v-for="(item) in cylinderOptions" :key="item.id" :value="item.id">
                  {{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions style="justify-content: center;margin-bottom: 1rem">
            <md-button @click="closeEditModal" style="width: 106px;background-color: #fff !important;color:#000 !important;box-shadow: none !important;">Cancel</md-button>
            <md-button @click="saveChanges" class="md-primary" style="width: 106px;">Save</md-button>
          </md-dialog-actions>
        </md-dialog>
      </md-card-area>
    </md-card>

    <loader :is-visible="isLoading || isSaving" />
  </div>
</template>

<script>

import Swal from "sweetalert2";
import loader from "@/components/GlobeChek/loader.vue"

export default {
  name: 'SiViewConfigPage',
  components: {
    loader
  },
  data() {
    return {
      cylinderOptions: [
        {name: 'PLUS CYL', id: 'PLUS_CYLINDER'},
        {name: 'MINUS CYL', id: 'MINUS_CYLINDER'}
      ],
      showEditModal: false,
      orgToEdit: null,
      shopIdControl: [],
      organizations: [],
      shopIds: [],
      cylinderOptionControl: null,
      shopNamesObject: {},
      cylinderOptionsObject: {},
      isLoading: true,
      isSaving: false
    }
  },
  mounted() {
    this.getSiviewShops().then(()=>{
      this.getOrganizations();
    });
    
  },
  methods: {
    editOrgRelation(org) {
      this.orgToEdit = org;
      this.shopIdControl = org.shopIds;
      this.cylinderOptionControl = this.cylinderOptionsObject[org.organizationId] || null
      this.showEditModal = true;
    },
    formatCylinder(value) {
      const option = this.cylinderOptions.find(i=> i.id === value);
      return option ? option.name : '-'
    },
    async getSiviewShops() {
      try {
        const url = `${process.env.VUE_APP_URL}/siview/shops`
        const config = { headers: { 'Content-Type': 'application/json' } };
        const data = null;
        window.axios.get(url, data, config).then((res) => {
          this.shopIds = res.data;
          if (this.shopIds.length) {
            this.shopNamesObject = {};
            this.shopIds.forEach((shop) => {
              this.shopNamesObject[shop.id] = shop.name;
            });
          }
        }).catch((err) => {
          this.shopIds = [];
          this.isLoading = false;
        })
      } catch {
        this.shopIds = [];
        console.error('error while searching for shopIds')
      }
    },
    async getOrganizations() {
      try {
        this.isLoading = true;
        const userEmail = sessionStorage.getItem('username')
        const url = `${process.env.VUE_APP_URL}/siview-organizations/association/shop-organizations/${userEmail}`;
        const config = { headers: { 'Content-Type': 'application/json' } };
        const data = null;
        const res = await window.axios.get(url, data, config)
        this.organizations = res.data.organizations;
        this.organizations.sort((a,b)=> a.organizationName.toLowerCase() > b.organizationName.toLowerCase() ? 1 : -1);
        if (this.organizations.length) {
          this.organizations.forEach((org) => {
            if (org.shopIds.length) {
              org.shopIds = org.shopIds.map(id => parseInt(id, 10));
            }
          });
        }
        this.cylinderOptionsObject = {};
        const cylinderConfigs = await window.axios.get(`${process.env.VUE_APP_URL}/siview/organizations/cylinders`, null, config).then((res) => res.data);
        if (cylinderConfigs.length) {
          cylinderConfigs.forEach((cylinder) => {
            this.cylinderOptionsObject[cylinder.orgId] = cylinder.defaultOption;
          });
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.organizations = [];
        Swal.fire({
          title: "Error",
          text: "It was not possible to retrieve organizations. Please try again later",
          type: "error",
          confirmButtonClass: "md-button md-info",
          buttonsStyling: false,
          timer: 3000
        })
        console.error('error while searching for organizations', err)
      }
    },
    closeEditModal() {
      this.orgToEdit = null;
      this.showEditModal = false;
    },
    async saveChanges() {
      try {
        this.isSaving = true;
        const userEmail = sessionStorage.getItem('username')
        const url = `${process.env.VUE_APP_URL}/siview-organizations/edit/association/shop-organizations/${this.orgToEdit.organizationId}/${userEmail}`
        const config = { headers: { 'Content-Type': 'application/json' } };
        const data = { shopIds: this.shopIdControl };
        await window.axios.put(url, data, config);
        await window.axios.put(`${process.env.VUE_APP_URL}/siview/${this.orgToEdit.organizationId}/cylinder`, {
          defaultOption: this.cylinderOptionControl,
        }, config);
        this.getOrganizations();
        this.showEditModal = false;
        Swal.fire({
          title: "Success!",
          text: "Organization was updated successfully!",
          timer: 1500,
          type: "success",
          showConfirmButton: false
        })
        this.cylinderOptionControl = null;
        this.shopIdControl = null;
        this.orgToEdit = null;
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: "It was not possible to update this organization. Please try again later",
          type: "error",
          confirmButtonClass: "md-button md-info",
          buttonsStyling: false,
          timer: 3000
        })
        console.error('error trying do update org.', err)
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">

.org-item:hover {
  background: lightgray;
}

.d-flex {
  display: flex;
}

.flex-row {
  flex-direction: row;
}

.flex-column {
  flex-direction: column;
}

.align-items-center {
  align-items: center;
}

.justify-content-between {
  justify-content: space-between;
}

.cheap {
  border-radius: 12px;
  padding: 2px 8px;
  width: max-content;
  background-color: #66bb6a;
  color: white;
  font-weight: 500;
  font-size: 12px;
  max-height: 32px;
}

.pointer {
  cursor: pointer
}

#org_shop_relation_card {
  // padding: 8px 0;
  margin: 24px;
  // border: 1px solid #dbdbdbc7;
  // border-radius: 16px;

  .item {
    border-bottom: 1px solid #dbdbdbc7;
    &:last-of-type {
      border-bottom: none;
    }

    .icon-btn {
      padding: 8px;
      border-radius: 8px;
      background-color: #0b6c8d;

      i {
        color: white;
      }
    }

    p.warning-color {
      color: rgb(237, 118, 50);
      font-weight: 500;
    }
  }

  //&:last-child {
  //  border-bottom: none;
  //}

  //.md-dialog-container {
  //  background: transparent !important;
  //}

  //.md-dialog-container .md-overlay {
  //  display: none !important;
  //}

}

</style>